import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP — see metadata.md "Grounding note":
//   admin-client.ts (singleton/6-socket), query-expander.ts (3,158 acronyms),
//   query-rewriter.ts:172 (<3), mcp/tools.ts (provider_type/last_sync_at/chunk_loc/metadata_graph),
//   chat/completions/route.ts:378 (DECISION FRAMEWORK / Default to CASE A).

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "My sync engine hung at twenty-two percent. No error, no crash — every single time, exactly 22%." },
];

export const BUG1: ScriptLine[] = [
  { scene: "bug1", fromSec: 0.4, holdSec: 6, caption: "Three days of wrong guesses: rate limits, out of memory, DNS. All dead ends." },
  { scene: "bug1", fromSec: 6.6, holdSec: 7, caption: "The clue: ALWAYS 22% — never random. So it was deterministic, not a network glitch." },
  { scene: "bug1", fromSec: 13.8, holdSec: 6, caption: "Six modules each called createClient(). Node caps sockets at 6 per host." },
  { scene: "bug1", fromSec: 19.9, holdSec: 3, caption: "Every socket held by Supabase — the embedding call to OpenRouter hung forever." },
];

export const BUG2: ScriptLine[] = [
  { scene: "bug2", fromSec: 0.4, holdSec: 6, caption: "\"What is the Pareto principle?\" returned nothing — even with a 0.87 vector match sitting right there." },
  { scene: "bug2", fromSec: 6.6, holdSec: 6.5, caption: "The query expander auto-derived 3,158 acronyms from entity names — including IS, IT, AT." },
  { scene: "bug2", fromSec: 13.4, holdSec: 6, caption: "So \"is\" matched \"IS\" → is_superadmin. A normal English word became a column name." },
];

export const BUG3: ScriptLine[] = [
  { scene: "bug3", fromSec: 0.4, holdSec: 5.5, caption: "My MCP server worked in dev. In prod every list_sources call returned a 500." },
  { scene: "bug3", fromSec: 6.2, holdSec: 6, caption: "I wrote the tools from memory. Four column names were wrong." },
  { scene: "bug3", fromSec: 12.6, holdSec: 5, caption: "Two hours of debugging. The fix: rename four columns to match the migrations." },
];

export const BUG4: ScriptLine[] = [
  { scene: "bug4", fromSec: 0.4, holdSec: 6.5, caption: "\"How does auth work?\" — five chunks, scores above 0.85 — and the LLM said: not available." },
  { scene: "bug4", fromSec: 7.1, holdSec: 6.5, caption: "Not a code bug. A prompt bug. Strict-source rules let it bail if the exact phrase was missing." },
  { scene: "bug4", fromSec: 13.9, holdSec: 6.5, caption: "Fix: a decision tree with one default — CASE A. Refusing now needs proof of irrelevance." },
];

export const LESSON: ScriptLine[] = [
  { scene: "lesson", fromSec: 0.4, holdSec: 6.5, caption: "Every fix was tiny — a singleton, a threshold, four renames, a prompt rewrite." },
  { scene: "lesson", fromSec: 7.1, holdSec: 7, caption: "The diagnosis was the hard part. None of these show up in dev — only at scale, with real users." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Junior vs senior isn't avoiding bugs — it's how fast you find the root cause." },
  { scene: "outro", fromSec: 5.8, holdSec: 4.5, caption: "Next: why vector search alone can't find the word 'pgvector' — and the hybrid fix." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
